<template>
<v-app light>
    <v-navigation-drawer 
        app
        fixed right
        class="hidden-md-and-up" 
        light
        width="250"
        disable-resize-watcher
        v-model="websiteDrawer"
    >
        <v-toolbar flat>
            <v-list>
                <v-list-tile>
                    <v-list-tile-title class="title">
                        {{$t('app_name')}}
                    </v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-toolbar>
        <v-divider></v-divider>
        <!-- <v-text-field
            :label="$t('search')"
            v-model="search"
            clearable
            hide-details
            single-line
            solo flat
            append-icon="search"
            class=""
        ></v-text-field> -->
        <v-list class="pt-0">
            <v-list-tile  :to="item.link" exact v-for="item in menuItems" :key="item.title">
                <v-list-tile-action>
                    <v-icon>{{item.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title v-text="$t(item.title)"></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>

    <v-toolbar app clipped-right>
        <v-tooltip bottom open-delay='0' close-delay='0'>
            <img class="mt-2" slot="activator" src="images/icons/fafa-logo-min.png" alt="fafa-logo" width="100" />
            <span>{{$t('app_name')}}</span>
        </v-tooltip>
        
        <v-spacer></v-spacer>
        <!-- <v-text-field
            :label="$t('search')"
            v-model="search"
            clearable
            hide-details
            single-line
            solo flat
            append-icon="search"
            class="hidden-sm-and-down mr-3"
        ></v-text-field> -->
        <v-btn depressed class="hidden-sm-and-down" active-class="default-class primary" to="/" exact>{{$t('home')}}</v-btn>
        <v-btn depressed class="hidden-sm-and-down" active-class="default-class primary" to="/our-product" exact>{{$t('product')}}</v-btn>
        <v-btn depressed class="hidden-sm-and-down" active-class="default-class primary" to="/about-us" exact>{{$t('about_us')}}</v-btn>
        <v-menu bottom left>
            <v-btn icon slot="activator"><v-icon>language</v-icon></v-btn>
            <v-list>
                <v-list-tile v-for="(value, key) in locales" :key="key" @click.prevent="setLocale(key)" :class="{'primary' : key == locale}">
                    <v-list-tile-title v-text="value"></v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
        <v-btn icon class="hidden-md-and-up" @click.stop="websiteDrawer = !websiteDrawer"><v-icon color="primary">menu</v-icon></v-btn>
    </v-toolbar>
    <v-content>
        <router-view />
    </v-content>
    <v-footer height="auto" >
        <v-container>
            <v-layout row justify-center>
                <v-flex xs12>
                    <v-card light class="text-xs-center" style="border-radius: 10px;">
                        <v-card-text>
                            <img style="margin-bottom: -85px;" src="images/red-min.png" alt="fafa-logo" width="300px"/>
                            <div style="margin-bottom: 30px;" class="headline white--text">{{$t('contact_us')}}</div>

                            <v-layout row wrap>
                                <v-flex xs12 sm4 class="pt-3">
                                    <v-icon>home</v-icon>
                                    <div class="">
                                        {{$t('fafafood_address')}}
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm4 class="pt-3">
                                    <v-icon>phone</v-icon>
                                    <div>
                                        + (855) 23 65 99999 / + (855) 23 996 869
                                    </div>
                                    <div>
                                        + (855) 11 772 226 / + (855) 12 305 238
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm4 class="pt-3">
                                    <v-icon>email</v-icon>
                                    <div class="">
                                        info@fafafood.com
                                    </div>
                                </v-flex>
                                <!-- <v-flex xs12 class="pt-3 px-1">
                                    <v-icon>pin_drop</v-icon>
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3909.175242932434!2d104.90303441500221!3d11.539283591806633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310950e35d40e77d%3A0x9f05bcf777b7d34d!2sFafa+Food!5e0!3m2!1skm!2skh!4v1513606061883" 
                                            frameborder="0" 
                                            style="border: 0px;width: 100%;height: 250px;border-radius: 10px;" 
                                            allowfullscreen
                                    >
                                    </iframe>
                                </v-flex> -->
                            </v-layout>                  
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-footer>
</v-app>
</template>
<script>
import { mapGetters } from "vuex";
import { loadMessages } from "~/plugins/i18n";

export default {
 	name: 'WebsiteLayout',
    metaInfo () {
        return { title: this.$t('home') }
    },

    computed: mapGetters({
        user: "auth/user",
        locale: "lang/locale",
        locales: "lang/locales"
    }),

    data: () => ({
        title: window.config.appName,
        search: '',
        websiteDrawer: false,
        menuItems: [
            {
                icon: "home",
                title: "home",
                link: "/"
            },
            {
                icon: "shopping_basket",
                title: "product",
                link: "/our-product"
            },
            {
                icon: "info",
                title: "about_us",
                link: "/about-us"
            },
            {
                icon: "vpn_key",
                title: "login",
                link: "/login"
            }
        ]
    }),

    methods: {
        setLocale (locale) {
            if (this.$i18n.locale !== locale) {
                loadMessages(locale)

                this.$store.dispatch('lang/setLocale', { locale })
            }
        },
        login() {
            this.$router.push({ name: 'login' })
        }
    }
}
</script>

<style scoped>
.top-right {
  position: absolute;
  right: 10px;
  top: 18px;
}

.title {
  font-size: 85px;
}

footer{
    background-image: url(/images/footer-back-min.png) !important;
    background-size: contain !important;
    background-repeat: round !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/website.vue